export default "__VITE_ASSET__cfOwJIov__"